<script>
    import Swiper from "@/plugins/swiper-bundle";
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "ModalGallery",
        components: {
            TheSvgIcon,
        },
        props: {
            images: {
                type: Array,
                required: true,
            },
            type: String,
        },
        data() {
            return {
                slider: null,
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.slider = new Swiper(".js-modal-gallery-slider", {
                    spaceBetween: 10,
                    slidesPerView: 1,
                    effect: "fade",
                    direction: "horizontal",
                    grabCursor: true,
                    lazy: true,
                    navigation: {
                        nextEl: `.js-modal-gallery-slider-next`,
                        prevEl: `.js-modal-gallery-slider-prev`,
                    },
                });
            });

            setTimeout(() => {
                if (this.images.length > 1) {
                    this.$refs.modalGallerySlider.focus();
                }
            }, 500);
        },
        methods: {
            getImageUrl(name) {
                return `/static/picooc/${this.type}/faq/${name}`;
            },
        },
    };
</script>

<template>
    <div class="modal-gallery">
        <div class="modal-gallery__slider">
            <div class="modal-gallery-slider" ref="modalGallerySlider" tabindex="0">
                <button
                    v-if="images.length > 1"
                    class="modal-gallery-slider__arrow modal-gallery-slider__arrow--prev outline js-modal-gallery-slider-prev"
                >
                    <the-svg-icon name="arrow" :size-w="24"></the-svg-icon>
                </button>
                <div
                    class="swiper-container modal-gallery-slider__slider js-modal-gallery-slider"
                >
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide modal-gallery-slider__slide"
                            v-for="(image, index) in images"
                            :key="index"
                        >
                            <img class="swiper-lazy" :src="getImageUrl(image)" alt="" />
                        </div>
                    </div>
                </div>
                <button
                    v-if="images.length > 1"
                    class="modal-gallery-slider__arrow modal-gallery-slider__arrow--next outline js-modal-gallery-slider-next"
                >
                    <the-svg-icon name="arrow" :size-w="24"></the-svg-icon>
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .modal-gallery-slider {
        position: relative;
        outline: none;
    }

    .modal-gallery-slider__slider {
        img {
            user-select: none;
            border-radius: 15px;
            margin: 0 auto;

            @include bp($bp-desktop-sm) {
                max-height: 80vh;
            }
        }
    }
    .modal-gallery-slider__arrow {
        position: absolute;
        z-index: 1000;
        top: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        background-color: var(--primary--dark);
        border-radius: 50%;
        cursor: pointer;
        svg {
            fill: #fff;
        }
        @include bp($bp-desktop-sm) {
            background-color: transparent;
            svg {
                fill: var(--primary--dark);
            }
        }
        &[aria-disabled="true"] {
            opacity: 0.5;
        }
    }

    .modal-gallery-slider__arrow--prev {
        left: -20px;
    }

    .modal-gallery-slider__arrow--next {
        right: -20px;
        svg {
            transform: rotate(180deg);
        }
    }
</style>
